import { render, staticRenderFns } from "./FileNew.vue?vue&type=template&id=701424ec&scoped=true&"
import script from "./FileNew.vue?vue&type=script&lang=js&"
export * from "./FileNew.vue?vue&type=script&lang=js&"
import style0 from "./FileNew.vue?vue&type=style&index=0&id=701424ec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701424ec",
  null
  
)

export default component.exports